/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import getSearchEvents from '../../../../api/graphql/queries/searchEvents';
import Modal from '../../../Modal/Modal';

const CollapsibleListContent = ({
  activeLanguage,
  reusableComponents,
  updateComponentInParentState,
  selected,
  languages,
  index,
  reusableComponent,
  slider,
  component,
  deleteItemHandler,
  match: { params },
}) => {
  const styles = {
    position: 'absolute',
    width: '98%',
    height: '48px',
    marginLeft: '2%',
    overflow: 'visible',
    pointerEvents: 'auto',
    transformOrigin: '50% 50% 0px',
    bordeRadius: '5px',
    color: 'white',
    lineHeight: '66px',
    paddingLeft: '32px',
    fontSize: '14.5px',
    background: '#c8c8c8',
    textTransform: 'uppercase',
    letterSpacing: '0px',
  };

  // const [index, setIndex] = useState();
  const [showForm, setShowForm] = useState(false);
  const [state, setState] = useState(component);
  const [post, setPost] = useState('');
  const [reusableList, setReusableList] = useState([]);

  useEffect(() => {
    setState(component);
    if (
      component
      && component.components
      && component.components[0]
      && component.components[0].key
    ) {
      setPost(component.components[0].key);
    }
  }, [component]);

  const searchEventHandler = (e) => {
    const { value } = e.target;
    if (value === '') return setPost('');
    const list = reusableComponents.filter(item => item.slugName.includes(value));
    setReusableList(list);
  };

  const selectPostHandler = (slugName, del = false) => {
    // update component State
    let newState;
    if (del) {
      setPost('');
      newState = {
        ...state,
        components: [],
      };
    } else {
      setPost(slugName);
      setReusableList([]);
      newState = {
        ...state,
        components: [{ key: slugName }],
      };
    }
    setState(newState);

    // upadte component in its parent
    updateComponentInParentState(newState, index);
  };

  const inputTextMultilangHandler = (e) => {
    const { value, lang } = e.target;
    const newState = {
      ...state,
      text: {
        ...state.text,
        [lang]: value,
      },
    };

    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const inputButtonTextMultilangHandler = (e) => {
    const { value, lang } = e.target;
    const newState = {
      ...state,
      button: {
        ...state.button,
        text: {
          ...state.button.text,
          [lang]: value,
        },
      },
    };

    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const inputCategoryHandler = (e) => {
    const { value } = e.target;
    const newState = {
      ...state,
      button: {
        ...state.button,
        category: value,
      },
    };
    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const handleClick = () => {
    setShowForm(!showForm);
  };

  return (
    <>
      {showForm && (
        <Modal
          title="Select post"
          handleClick={handleClick}
          type="display"
          positionMiddle
          size={`w-5/6 ${reusableList.length > 0 && 'h-112'}`}
        >
          <div
            className={`bg-greyWithinForm mt-6 mr-4 ml-2 mb-2 rounded-lg ${reusableList.length
              > 0 && 'h-72'}`}
          >
            <div>
              <p className="text-xs uppercase pl-1 text-white font-americaMonoRegular mb-0 pl-6 mt-1 pt-2">
                Search post
              </p>
              <input
                className={`rounded-full pr-4 pl-8 py-1 h-8 outline-none mx-4 font-americaMonoRegular text-sm w-7/8 mt-1 ${reusableList.length
                  === 0 && 'mb-2'}`}
                type="text"
                onChange={searchEventHandler}
              />
              <span className="font-icon icon-search z-5 text-black absolute mt-3 ml-13 text-sm left-0" />
            </div>
            {reusableList.length > 0 && (
              <div className="px-4">
                <p
                  className={`font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mt-3.5 mb-0 mr-2 pb-1 pt-1 w-full py-2 rounded-t-lg ${
                    post ? 'py-2' : 'pb-1'
                  }`}
                >
                  Available posts
                </p>
                <div className="first-child overflow-auto bg-greyFilterItems rounded-b-lg pb-2 mr-4 max-h-150 w-full">
                  {reusableList.map(x => (
                    <div
                      className="cursor-pointer"
                      onClick={() => selectPostHandler(x.slugName)}
                      key={x.slugName}
                    >
                      <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mb-0 mt-0">
                        {x.slugName}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {post && (
              <div
                className={`${
                  reusableList.length > 0 ? 'mt-56' : 'mt-0'
                } mx-4 pb-4`}
              >
                <p className="font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mb-0 mr-2 pb-1 mt-0 w-full py-2 rounded-t-lg py-2">
                  Selected post
                </p>
                <div className="overflow-auto bg-greyFilterItems rounded-b-lg max-h-150 w-full">
                  <div>
                    <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mb-0 mt-0">
                      {post}
                      <span
                        className="font-icon icon-close-btn1 absolute text-black text-12 font-thin right-0 relative pl-1"
                        onClick={() => selectPostHandler(post, true)}
                      />
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
      <div className="bg-greyFilter">
        <div
          className="w-full p-4 pl-6 ml-1 pr-2 flex flex-col justify-center rounded-br-lg"
          style={styles}
        >
          <div className="flex items-center">
            {languages.map(lang => (
              <div
                key={lang}
                className={`w-2/5 h-fit-content ${
                  activeLanguage.toLowerCase() === lang.toLowerCase()
                    ? 'block'
                    : 'hidden'
                } `}
              >
                <label
                  className="flex font-americaMonoRegular text-xs uppercase text-black h-10 items-center"
                  htmlFor="title"
                >
                  title
                  <input
                    className="withinSlider text-sm font-americaMonoRegular bg-white outline-none w-full rounded-full h-8 px-4"
                    onChange={inputTextMultilangHandler}
                    name="text"
                    lang={lang.toLowerCase()}
                    type="text"
                    value={state.text[lang.toLowerCase()]}
                  />
                </label>
              </div>
            ))}
            <div className="w-2/5 block h-fit-content flex md:flex-col">
              <label
                className="flex font-americaMonoRegular text-xs uppercase text-black h-10 items-center ml-2"
                htmlFor="tag"
              >
                category
                <input
                  className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full text-sm px-2 h-8"
                  onChange={inputCategoryHandler}
                  name="category"
                  type="text"
                  value={state.button.category}
                />
              </label>
              {languages.map(lang => (
                <div
                  key={lang}
                  className={`h-fit-content ${
                    activeLanguage.toLowerCase() === lang.toLowerCase()
                      ? 'block'
                      : 'hidden'
                  } `}
                >
                  <label
                    className="flex font-americaMonoRegular text-xs uppercase text-black h-10 items-center ml-2"
                    htmlFor="title"
                  >
                    text
                    <input
                      className="withinSlider text-sm font-americaMonoRegular bg-white outline-none w-full rounded-full h-8 px-4"
                      onChange={inputButtonTextMultilangHandler}
                      name="button-text"
                      lang={lang.toLowerCase()}
                      type="text"
                      value={state.button.text[lang.toLowerCase()]}
                    />
                  </label>
                </div>
              ))}
            </div>
            <div className="relative w-1/5 h-fit-content flex items center md:flex-col">
              <button
                type="button"
                className="font-americaMonoBold text-xxs px-2 py-1 h-7 mx-2 rounded-full uppercase bg-black text-white flex items-center"
                onClick={handleClick}
              >
                {post ? 'Change post' : 'Select post'}
                <span className="font-icon icon-add-button text-base pl-2" />
              </button>
              {post ? (
                <Link
                  to={`/cms/structure/${params.postCategory}/${post}`}
                  target="_blank"
                >
                  <button
                    type="button"
                    className="font-americaMonoBold text-xxs px-2 py-1 h-7 mr-2 rounded-full uppercase bg-black text-white flex items-center"
                  >
                    Edit post
                    <span className="font-icon icon-edit text-base font-bold pl-2" />
                  </button>
                </Link>
              ) : (
                <Link
                  to={`/cms/stucture/${params.postCategory}/choose-layout/ReusableComponent`}
                  target="_blank"
                >
                  <button
                    type="button"
                    className="font-americaMonoBold text-xxs px-2 py-1 h-7 mr-2 rounded-full uppercase bg-black text-white flex items-center"
                  >
                    Add new post
                    <span className="font-icon icon-add-button text-base font-bold pl-2" />
                  </button>
                </Link>
              )}
            </div>
            <div
              className="absolute right-0 top-0 h-10 flex items-end mt-1"
              onClick={() => deleteItemHandler(index)}
            >
              <span className="font-icon icon-close-solid text-16 text-white" />
            </div>
          </div>
          <div />
        </div>
      </div>
    </>
  );
};

CollapsibleListContent.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  component: PropTypes.shape(),
  slider: PropTypes.bool,
  reusableComponents: PropTypes.arrayOf(PropTypes.shape({})),
};
CollapsibleListContent.defaultProps = {
  reusableComponent: null,
  reusableComponents: [],
  slider: false,
  component: null,
};

export default withRouter(CollapsibleListContent);
